import { block as _block$ } from "million/react";
import React from "react";

// Componente de fondo simplificado - solo 2 variantes
const M$ = ({
  variant = "glows"
}) => {
  // Fondo tipo Portafolio: puntos sutiles + glows suaves
  if (variant === "dots") {
    return <div className="absolute inset-0 overflow-hidden pointer-events-none">
                {/* Grid de puntos sutiles */}
                <div className="absolute inset-0" style={{
        backgroundImage: `radial-gradient(rgba(189, 255, 87, 0.03) 1.2px, transparent 2.5px)`,
        backgroundSize: '40px 40px'
      }} />
                
                {/* Glow suave superior derecha */}
                <div className="absolute -top-20 right-1/4 w-80 h-80 bg-[#bdff57]/5 rounded-full blur-3xl" />
                
                {/* Glow suave inferior izquierda */}
                <div className="absolute bottom-0 left-1/3 w-96 h-96 bg-[#bdff57]/3 rounded-full blur-3xl" />
            </div>;
  }

  // Fondo negro con iluminaciones verdes (default)
  return <div className="absolute inset-0 overflow-hidden pointer-events-none">
            {/* Glow superior derecha */}
            <div className="absolute top-0 right-1/4 w-96 h-96 bg-[#bdff57]/5 rounded-full blur-3xl" />
            
            {/* Glow inferior izquierda */}
            <div className="absolute bottom-0 left-1/4 w-80 h-80 bg-[#bdff57]/3 rounded-full blur-3xl" />
        </div>;
};
const AbstractBackground = M$;
export default AbstractBackground;